import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { AssetsService } from 'src/app/services/assets.service';

@Component({
  selector: 'app-generate-auto-post-dialog',
  templateUrl: './generate-auto-post-dialog.component.html',
  styleUrl: './generate-auto-post-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class GenerateAutoPostDialogComponent {
  shootAssetId: string = '';
  models: string[] = [];
  rtProfiles: string[] = [];
  autoPipelines: string[] = [];
  selectedModel: string | null = null;
  selectedRtProfile: string | null = null;
  selectedAutoPipeline: string | null = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GenerateAutoPostDialogComponent>,
    public dialog: MatDialog,
    private assetsService: AssetsService,
    private alertService: AlertService,
  ) {
    this.shootAssetId = data.shootAssetId;
  }

  ngOnInit(): void {
    this.getAvailableInputs();
  }

  getAvailableInputs() {
    forkJoin({
      models: this.assetsService.getAvailableGptModels(),
      rtProfiles: this.assetsService.getAvailableRtProfiles(),
      autoPipelines: this.assetsService.getAvailableAutoPipelines(),
    }).subscribe(({ models, rtProfiles, autoPipelines }) => {
      // Set data lists
      this.models = models;
      this.rtProfiles = rtProfiles;
      this.autoPipelines = autoPipelines;

      // set defaults
      this.selectedModel = models[0];
      this.selectedRtProfile = rtProfiles[0];
      this.selectedAutoPipeline = autoPipelines[0];
    });
  }

  generateAutoPostAsset() {
    this.assetsService
      .generatePostAsset(
        this.shootAssetId,
        this.selectedModel!,
        this.selectedRtProfile!,
        this.selectedAutoPipeline!,
      )
      .subscribe(() => {
        this.dialogRef.close();
        this.alertService.successToast('Asset quered for post asset generation.');
      });
  }
}
